export default {
  Title: 'Stores | Store | Stores',

  List: {
    Title: 'See our stores'
  },

  SelectStoreDialog: {
    Title   : 'Stores',
    Subtitle: 'Select store'
  },

  Status: {
    Opened        : 'Open',
    Closed        : 'Closed',
    ClosedNoOrders: 'The store is closed and does not accept orders!',
    NoDelivery    : 'The store does not accept delivery orders!',
    NoCollection  : 'The store does not accept collection orders!'
  },

  OrderTime: {
    Suffix  : '@:Store.OrderTime.SuffixSM',
    SuffixXL: '@:Store.OrderTime.SuffixLG',
    SuffixLG: 'mins.',
    SuffixMD: '@:Store.OrderTime.SuffixSM',
    SuffixSM: 'mins.',
    SuffixXS: '\''
  }
}
